module.exports = __webpack_public_path__ + "kusamaproject/img/1.3ba87cd7.jpg";